export const STATUS_SUCCESS = 0;
export const STATUS_FAILURE_NOT_AUTHORIZED = 257;
export const STATUS_FAILURE_ILLEGAL_REQUEST = 258;
export const STATUS_FAILURE_NOT_AUTHORIZED_DEMO = 259;
export const STATUS_FAILURE_NO_TARGET = 260;
export const STATUS_FAILURE_NO_OPTION = 261;
export const STATUS_ERROR_INTERNAL = 513;
export const STATUS_FAILURE_IDPASSWORD = 263;
export const STATUS_FAILURE_STATUS = 264;
export const STATUS_FAILURE_DUPLICATE_TARGET = 261;
export const STATUS_FAILURE_OP_NOT_AUTHORIZED = 1001;

export const STATUS_FAILURE_NO_OWNER = 1011;
export const STATUS_FAILURE_NO_OFFICE = 1012;
export const STATUS_FAILURE_NO_SHOP = 1013;
export const STATUS_FAILURE_NO_STAFF = 1014;
export const STATUS_FAILURE_NO_HIME = 1015;
export const STATUS_FAILURE_NO_DRIVER = 1016;
export const STATUS_FAILURE_NO_USER = 1021;
export const STATUS_FAILURE_NO_RESV = 1022;
export const STATUS_FAILURE_NO_CALL = 1023;
export const STATUS_FAILURE_NO_SP = 1031;
export const STATUS_FAILURE_NO_MONEYEXCH = 1032;
export const STATUS_FAILURE_NO_INFORM = 1033;

export const STATUS_FAILURE_CTR_POINT = 1101;
export const STATUS_FAILURE_CTR_SHOPCOUNT = 1102;
export const STATUS_FAILURE_CTR_SPCOUNT = 1103;
export const STATUS_FAILURE_CTR_PCCOUNT = 1104;
export const STATUS_FAILURE_CTR_HIMECOUNT = 1105;

export const STATUS_FAILURE_OFFICE_FIX = 1201;
export const STATUS_FAILURE_OFFICE_NOFIX = 1202;
export const STATUS_FAILURE_OFFICE_FIX_PRECOND = 1203;
export const STATUS_FAILURE_OFFICE_POINT_SHORTAGE = 1204;
export const STATUS_FAILURE_HIMEDAY_FIX = 1211;
export const STATUS_FAILURE_HIMEDAY_NOFIX = 1212;
export const STATUS_FAILURE_HIMEDAY_FIX_PRECOND = 1213;
export const STATUS_FAILURE_HIMEDAY_MONEY_EXISTS = 1214;

export const STATUS_FAILURE_USER_DUP_MID = 1301;
export const STATUS_FAILURE_USER_DUP_PHONE = 1302;
export const STATUS_FAILURE_USER_DUP_CALL = 1303;
export const STATUS_FAILURE_USER_DUP_LUID = 1304;
export const STATUS_FAILURE_RESV_FIRSTMEDIA = 1401;
export const STATUS_FAILURE_RESV_POINT = 1402;
export const STATUS_FAILURE_RESV_DUPCALL = 1403;
export const STATUS_FAILURE_RESV_MONEYTEMP_EXISTS = 1404;
export const STATUS_FAILURE_RESV_RECV_EXISTS = 1405;
export const STATUS_FAILURE_RESV_RECV_STATUS = 1406;

export const STATUS_FAILURE_CALL_UPD_TIMEOUT = 1501;
export const STATUS_FAILURE_CALL_TAKE_EXISTS = 1502;
export const STATUS_FAILURE_CALL_TYPE_RESV = 1503;

export const STATUS_FAILURE_SCHEDULE_DRIVER_MONEYEIXSTS = 1601;

export const STATUS_FAILURE_MESSAGE_MAILSENDFAILURE = 1701;

export const STATUS_FAILURE_UP_NOAUTH = 3001;
export const STATUS_FAILURE_UP_AUTHTIMEOUT = 3002;
export const STATUS_FAILURE_SP_EXISTSSP = 3101;
export const STATUS_FAILURE_SP_REGISTERDONE = 3102;
export const STATUS_FAILURE_TOP_EXISTSOWNER = 4001;
export const STATUS_FAILURE_TOP_REGISTERDONE = 4002;
export const STATUS_FAILURE_PCMAIN_NOTREGISTER = 4101;
export const STATUS_FAILURE_PCMAIN_DUPLICATE = 4102;

export const STATUS_FAILURE_NOTIFY_REGISTERKEY = 4201;
export const STATUS_FAILURE_NOTIFY_TOKEN = 4202;
export const STATUS_FAILURE_NOTIFY_TOKEN_EXISTS = 4203;
export const STATUS_FAILURE_NOTIFY_ADDR = 4204;
export const STATUS_FAILURE_NOTIFY_LINE_DISABLED = 4205;
export const STATUS_FAILURE_LINE_ERROR = 4220;

export const STATUS_FAILURE_AUTH = 4301;

export const STATUS_FAILURE_NET_USER = 4401;
export const STATUS_FAILURE_NET_RESVSTATE = 4402;

export const MAIL_KEY = btoa('__owner_mail__');
export const PASS_KEY = btoa('__owner_password__');

export const BASE_URL = `${location.protocol}//${location.host}`;
export const API_BASE = BASE_URL + '/ajax';
export const HEADERKEY_OFFICE_ID = 'fcti_office_id';

/**
 * @type {Readonly<Record<string, string>>}
 */
export const ALL_SERVER_LIST = Object.freeze({
  'cti1': 'https://cti1.fuzoku-fan.jp',
  'cti2': 'https://cti2.fuzoku-fan.jp',
  'cti3': 'https://cti3.fuzoku-fan.jp',
  'cti3795': 'https://cti3795.fuzoku-fan.jp',
});

/**
 * @type {Readonly<Record<string, Set<string>>>}
 */
export const AVAILABLE_SERVER_MAP = Object.freeze({
  // 本番のデータでテストする場合、これを uncomment して webpack.common.js の HOST を cti1.fuzoku-fan.jp に変える
  //'localhost:4500': new Set(['cti2', 'cti3']),
  'cti1.fuzoku-fan.jp': new Set(['cti2', 'cti3']),
});

// /**
//  * @type {Readonly<Record<string, Record<string, string | undefined>>>}
//  */
// export const EMAIL_REPLACE_MAP = Object.freeze({
//   'cti2': Object.freeze({
//     'admin@knowledge-flow.net': 'admin2@knowledge-flow.net',
//   })
// });

/**: 
 * @type {Readonly<Record<string, string>>}
 */
export const SERVER_LIST = Object.entries(ALL_SERVER_LIST)
  .filter((x) => AVAILABLE_SERVER_MAP[location.host]?.has(x[0]))
  .reduce((obj, [key, val]) => {
    obj[key] = val;
    return obj;
  }, {});

export const USE_OTHER_SERVER = true;
export const SERVER_STATE_INIT = 0;
export const SERVER_STATE_ONLINE = 1;
export const SERVER_STATE_OFFLINE = 2;


export const FOLDED_MESSAGE = '別の詳細画面が開かれています。このまま新しい詳細画面を開きますか？';
export const RESV_FOLDED_MESSAGE = '編集中の予約が開かれています。';

export const MAXLEN_NAME = 40;
export const MAXLEN_VALUE = 60;
export const MAXLEN_TEXT = 255;
export const MAXLEN_IDLIST = 4000;
export const MAXLEN_MEMO = 4000;
export const MAXLEN_MEMO_LONG = 20000;
export const MAXLEN_JSON = 65535;

export const KF_OFFICE_ID = 'BNdizA';

const blnPrefixMap = {
  'cti1.fuzoku-fan.jp': '~',
  'cti2.fuzoku-fan.jp': '2~',
  'cti3.fuzoku-fan.jp': '3~',
  'cti3795.fuzoku-fan.jp': '3795~',
  'localhost:4500': '3795~',
};
export const BLN_PREFIX = blnPrefixMap[location.host] || '~';
